var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#4CDBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(78.494 65.587) scale(4.071244)",
    fill: "#000000",
    d: "M 47.5277,73.7027 C 32.0623,73.7027 21.312,62.6679 21.312,46.7703 C 21.312,30.8727 32.0623,19.8379 47.5277,19.8379 C 54.9909,19.8379 61.5246,22.0956 66.5495,26.4909 C 68.0313,27.7867 70.308,27.5462 71.4262,25.9431 L 78.8355,15.3358 C 79.7785,13.9865 79.563,12.143 78.3236,11.0608 C 70.106,3.95369 59.2075,0.0126953 47.5277,0.0126953 C 20.5576,0.0126953 6.10352e-05,20.399 6.10352e-05,46.7703 C 6.10352e-05,73.1416 20.5576,93.5279 47.5277,93.5279 C 59.0728,93.5279 69.85,89.6804 78.0272,82.7469 C 79.2936,81.6782 79.5091,79.8079 78.5661,78.4586 L 71.1433,67.8379 C 70.0386,66.2482 67.7889,65.9943 66.307,67.2635 C 61.309,71.5251 54.8697,73.716 47.5142,73.716 L 47.5277,73.7027"
  })));
};
export default SvgLogoNoText;